(function () {
    'use strict';

    angular.module("imApp").factory("ftpAccountService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 969,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 970,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 971,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
